import axios from "axios";

export const allUser = async (authtoken) => {
  return await axios.get(`${process.env.REACT_APP_API}/auth/getalluser`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const createUser = async (authtoken, userData) => {
  return await axios.post(`${process.env.REACT_APP_API}/auth/register`, userData, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const updateUser = async (authtoken, userId, userData) => {
  return await axios.put(`${process.env.REACT_APP_API}/auth/updateuser/${userId}`, userData, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const deleteUser = async (authtoken, userId) => {
  return await axios.delete(`${process.env.REACT_APP_API}/auth/deleteuser/${userId}`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const getUserById = async (authtoken, userId) => {
  return await axios.get(`${process.env.REACT_APP_API}/auth/getuser/${userId}`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const searchUsers = async (authtoken, name) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/user/searchtech`,
    { name },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const forceDisable2FA = async (authtoken, userId, enabled) => {
  return await axios.patch(`${process.env.REACT_APP_API}/2fa/force-disable/${userId}`, { enabled }, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const generateBackupCodes = async (authtoken, userId) => {
  return await axios.patch(`${process.env.REACT_APP_API}/2fa/force-backupcodes/${userId}`, {}, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

// User pagination API similar to techPagination
export const userPagination = async (authtoken, page, limit) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/user/techall?page=${page}&limit=${limit}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

// User details API similar to techDetails
export const userDetails = async (authtoken, id) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/auth/userdetails/${id}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

// Task assignment for users similar to taskAssign
export const userTaskAssign = async (authtoken, id) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/workOrders/userId/${id}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

// Update user API similar to updateTechApi
export const updateUserApi = async (authtoken, id, ...updateUser) => {
  return await axios.put(
    `${process.env.REACT_APP_API}/user/tech/${id}`,
    ...updateUser,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};


export const deleteUserApi = async (authtoken, id, deleteUser) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API}/user/tech`,
      {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
        data: {
          _id: id,
          deleteUser,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Axios error============>", error);
    throw error;
  }
};


// Suspend/unsuspend user
export const suspendUser = async (authtoken, _id, block) => {
  return await axios.patch(
    `${process.env.REACT_APP_API}/suspend/block`,
    { _id, block },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};
export const suspend = suspendUser;

// Export users as CSV
export const exportUsers = async (authtoken) => {
  return await axios.get(`${process.env.REACT_APP_API}/user/export`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
    responseType: "blob",
  });
};